import Axios from "axios";

interface IToken {
  access_token: string;
  expires_in: number;
  refresh_token: string;
  scope: string;
  token_type: string;

  retry_refresh?: boolean;
  expires_at?: number;
}

export class OAuthToken {
  private _accessToken: string = "";
  private _expiresIn: number = 0;
  private _refreshToken: string = "";
  private _scope: string = "";
  private _expiresAt: Date = new Date();
  private _retryRefresh: boolean = false;

  constructor(private readonly json: IToken) {
    if (json) {
      this.initValue(json);
    }
  }

  initValue(json: IToken) {
    const {
      access_token,
      expires_in,
      expires_at,
      refresh_token,
      retry_refresh,
      scope,
    } = json;
    this._accessToken = access_token;
    this._expiresIn = expires_in;
    this._refreshToken = refresh_token;
    this._scope = scope;
    this._expiresAt = expires_at
      ? new Date(expires_at)
      : new Date(Date.now() + this.expiresIn * 1000);
    this._retryRefresh = retry_refresh || false;

    // interceptors
    Axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;

    this.setStorage();
  }

  get accessToken() {
    return this._accessToken;
  }

  get expiresIn() {
    return this._expiresIn;
  }

  get refreshToken() {
    return this._refreshToken;
  }

  get scope() {
    return this._scope;
  }

  get expiresAt() {
    return this._expiresAt;
  }

  get isExpired() {
    return Date.now() > this.expiresAt.getTime();
  }

  get isAuthenticated() {
    return !this.isExpired && this.accessToken;
  }

  get retryRefresh() {
    return this._retryRefresh;
  }

  toString() {
    return JSON.stringify({
      access_token: this._accessToken,
      expires_in: this._expiresIn,
      refresh_token: this._refreshToken,
      scope: this._scope,
      retry_refresh: this._retryRefresh,
      expires_at: this._expiresAt.getTime(),
    });
  }

  setStorage() {
    localStorage.setItem("auth", this.toString());
  }
}
